import {notificationType, notificationStatus} from '../../../utils/constant';

function convertOneNetworkInvitationFromAPI(el) {
  if (!el) { return null; }
  return {
    invitationId: el.id,
    userId: el.userId,
    userFullname: el.userFullname,
    organisationName: el.invitedOrganisationName,
    email: el.invitedContactEmail,
    firstName: el.invitedContactFirstName,
    lastName: el.invitedContactLastName,
    customMessage: el.customMessage,
    status: el.status,
    language: el.invitedContactLanguage,
    creationDate: el.creationDate,
    lastSentDate: el.lastSentDate,
    token: el.token,
    resendable: el.resendable,
    rejectionReason: el.rejectionReason,
    registrationNumber: el.invitedRegistrationNumber,
    country: el.invitedOrganisationCountry,
    organisationId: el.organisationTargetId,
    accessCode: el.accessCode,
    clone: convertOneNetworkInvitationFromAPI(el.clone)
  };
}

export function convertNetworkInvitationsFromAPI(data) {
  return data.map(convertOneNetworkInvitationFromAPI);
}

export function convertNetworkInvitationsToAPI(data) {
  return data.map(el => ({
    status: el.status,
    invitedContactEmail: el.email,
    invitedOrganisationName: el.organisationName,
    invitedOrganisationCountry: el.country,
    invitedRegistrationNumber: el.registrationNumber,
    invitedVATIdentificationNumber: el.vatIdentificationNumber,
    invitingClientId: el.invitingClientId,
    invitingSubcontractorId: el.invitingSubcontractorId,
    customMessage: el.customMessage,
    invitedContactFirstName: el.firstName,
    invitedContactLastName: el.lastName,
    invitingCountry: el.invitingCountry,
    invitedContactLanguage: el.language,
    invitedContactPhoneNumber: el.phoneNumber
  }));
}

export function convertOneProjectInvitationFromAPI(el) {
  if (!el) { return null; }
  return ({
    invitationId: el.id,
    organisationSourceId: el.organisationSourceId,
    userId: el.userId,
    userFullname: el.userFullname,
    organisationName: el.invitedOrganisationName,
    email: el.invitedContactEmail,
    firstName: el.invitedContactFirstName,
    lastName: el.invitedContactLastName,
    customMessage: el.customMessage,
    emitterOrganisationId: el.emitterOrganisationId,
    status: el.status,
    language: el.invitedContactLanguage,
    creationDate: el.creationDate,
    lastSentDate: el.lastSentDate,
    token: el.token,
    resendable: el.resendable,
    invitationType: el.invitationType,
    projectId: el.project.projectId,
    rejectionReason: el.rejectionReason,
    accessCode: el.accessCode,
    registrationNumber: el.invitedRegistrationNumber,
    clone: convertOneProjectInvitationFromAPI(el.clone)
  });
}

export function convertProjectInvitationsFromAPI(data) {
  return data.map(convertOneProjectInvitationFromAPI);
}

export function convertProjectInvitationsToAPI(data) {
  return data.map(el => ({
    invitingCountry: el.invitingCountry,
    email: el.email,
    phoneNumber: el.phoneNumber,
    organisationName: el.organisationName,
    firstName: el.firstName,
    lastName: el.lastName,
    language: el.language,
    customMessage: el.customMessage,
    projectId: el.projectId,
    emitterOrganisationInterventionId: el.emitterOrganisationInterventionId,
    sourceRole: el.sourceRole,
    targetRole: el.targetRole,
    emitterOrganisationId: el.emitterOrganisationId,
    registrationNumber: el.registrationNumber,
    vatIdentificationNumber: el.vatIdentificationNumber,
    country: el.country
  }));
}

export function convertTokenFromAPI(data) {
  return {
    invitationId: data.id,
    email: data.invitedContactEmail,
    firstName: data.invitedContactFirstName,
    lastName: data.invitedContactLastName,
    phoneNumber: data.invitedContactPhoneNumber
  };
}

export function convertSuggestionsFromAPI(data) {
  return data.map(el => ({
    type: notificationType.RELATIONSHIP_SUGGESTED,
    status: notificationStatus.NEW,
    viewed: false,
    invitationId: el.invitationId,
    organisationId: el.invitingOrganisation.organisationId,
    registrationNumber: el.invitingOrganisation.registrationNumber,
    identificationNumbers: el.invitingOrganisation.identificationNumbers,
    invitingOrganisationName: el.invitingOrganisation.fullName,
    country: el.invitingOrganisation.country,
    address: el.invitingOrganisation.address
  }));
}
